import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import ModalWrapper from '../common/ModalWrapper';

interface Props extends PropsFromRedux {}

const ConfirmationModal: React.FC<Props> = ({ modal, hideModal }) => {
  const { header, body, confirmText, rejectText, rejectAction, confirmAction } =
    modal?.ownProps || {};
  return (
    <ModalWrapper hideModal={hideModal}>
      {/* <button
        type="button"
        arial-label="Close"
        onClick={() => {
          hideModal();
        }}
      >
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button> */}

      <div className="w-full flex flex-col items-center justify-center">
        <h2 className="font-bold text-3xl mb-5">{header || 'Are you sure?'}</h2>
        <p>
          {body ||
            'Kindly confirm that you want to perform the selected action'}
        </p>
        <div className="flex justify-evenly w-full my-10 gap-6">
          <button
            onClick={() => {
              rejectAction && rejectAction();
              hideModal();
            }}
            className="mb-2 font-medium px-10 border border-secondary text-secondary rounded p-3"
            type="button"
          >
            {rejectText || 'No'}
          </button>
          <button
            onClick={() => {
              confirmAction && confirmAction();
              hideModal();
            }}
            className="mb-2 font-medium px-10 bg-secondary text-white rounded p-3 "
            type="button"
          >
            {confirmText || 'Yes'}
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ConfirmationModal;
